import React, { useState, useEffect } from 'react';
import classes from './AccountingDashboard.module.css'
import { useLocation, useNavigate } from 'react-router-dom';
import HeaderNav from './HeaderNav/HeaderNav';
// import HeaderNav from '../Budget/Budget Dashboard/HeaderNav/HeaderNav';
import plus from '../../Assets/plus-icon.png';
import xport from '../../Assets/down.png';
import DollarIcon from '../../Assets/dollar.svg';
import DollarIcon2 from '../../Assets/dollar-green.svg';
import DollarIcon3 from '../../Assets/dollar-red.svg';
import DollarIcon4 from '../../Assets/dollar-blue.svg';
import DollarIcon5 from '../../Assets/dollar-purple.svg';
import DollarIcon6 from '../../Assets/naira.svg';
import ArrowDown from '../../Assets/arrow-blue.svg';
import ArrowDown2 from '../../Assets/arrow-green.svg';
import ArrowDown3 from '../../Assets/arrow-red.svg';
import ArrowDown4 from '../../Assets/arrow2-blue.svg';
import ArrowDown5 from '../../Assets/arrow-purple.svg';
import ArrowDown6 from '../../Assets/arrow-blue.svg';
import {
  LineChart, Line, YAxis, ResponsiveContainer, AreaChart, Area,
  BarChart, Bar, XAxis, CartesianGrid, Tooltip,
  PieChart, Pie, Cell, Legend
} from "recharts";


const revenueData = [
  { month: "Jan", revenue: 120, expenses: 80 },
  { month: "Feb", revenue: 150, expenses: 100 },
  { month: "Mar", revenue: 170, expenses: 120 },
  { month: "Apr", revenue: 140, expenses: 110 },
];

const cashflowData = [
  { month: "Jan", inflow: 90, outflow: 70 },
  { month: "Feb", inflow: 110, outflow: 90 },
  { month: "Mar", inflow: 100, outflow: 95 },
  { month: "Apr", inflow: 120, outflow: 85 },
];

const profitLossData = [
  { month: "Jan", profit: 400, loss: -200 },
  { month: "Feb", profit: 300, loss: -100 },
  { month: "Mar", profit: 500, loss: -250 },
  { month: "Apr", profit: 200, loss: -80 },
];

const expenseData = [
  { name: "Rent", value: 400 },
  { name: "Utilities", value: 300 },
  { name: "Marketing", value: 200 },
  { name: "Travel", value: 150 },
  { name: "Misc", value: 100 },
];

const COLORS = ["#B18FFF", "#16A34A", "#3B82F6", "#EF4444", "#F59E0B"];

const bankAccounts = [
  { bank: "Bank of America", account: "**** 1234", amount: "₦2,450,000", connected: true },
  { bank: "Chase Bank", account: "**** 5678", amount: "₦1,200,000", connected: true },
  { bank: "Wells Fargo", account: "**** 9101", amount: "₦800,000", connected: true },
];

const transactions = [
  {
    description: "Office Rent",
    time: "09:45 AM",
    type: "Expense",
    amount: -25000,
  },
  {
    description: "Client Payment",
    time: "11:20 AM",
    type: "Revenue",
    amount: 120000,
  },
  {
    description: "Utility Bills",
    time: "01:30 PM",
    type: "Expense",
    amount: -15000,
  },
];

const remittances = [
  {
    beneficiary: "John Doe",
    number: "REM-00123",
    date: "2025-09-10",
    amount: "₦75,000",
  },
  {
    beneficiary: "Jane Smith",
    number: "REM-00124",
    date: "2025-09-12",
    amount: "₦50,000",
  },
];



const AccountingDashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState('');
  const [bearer, setBearer] = useState('');

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');


      if (value !== null && value.trim() !== '') {
        setBearer(value);
      } else {
        navigate('/login');
        return;
      }

      if (value1 !== null) {
        setUser(value1);
      }

    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);



  const displayName = user ? user.split(" ")[0] : "User";

  const location = useLocation();




  return (
    <div className={classes.body}>
      <HeaderNav />
      <div className={classes.contentDiv}>
        <div className={classes.dashText}>
          <div className={classes.dashColm}>
            <h1 className={classes.headertxt}>Dashboard</h1>
            <p className={classes.smllittxt}>Welcome back, {displayName}! Here's your business overview for today.</p>
          </div>
          <div className={classes.btns}>
            <button className={classes.btncrte}><img src={plus} className={classes.plusicon} /> Monthly Remitances</button>
            <button className={classes.btnxprt}><img src={xport} className={classes.xprt} /> Upload Remitances</button>
          </div>
        </div>

        <div className={classes.cardContainer}>
          {[
            {
              label: "Total Revenue",
              value: "₦4,800,000",
              topIcon: DollarIcon,
              bottomIcon: ArrowDown,
              bottomText: "+12.5% from last month",
              bottomColor: "#3B82F6" // green
            },
            {
              label: "Net Profit",
              value: "₦4,800,000",
              topIcon: DollarIcon2,
              bottomIcon: ArrowDown2,
              bottomText: "+12.5% from last month",
              bottomColor: "#16A34A"
            },
            {
              label: "Total Expenses",
              value: "₦4,800,000",
              topIcon: DollarIcon3,
              bottomIcon: ArrowDown3,
              bottomText: "-12.5% from last month",
              bottomColor: "#FF0000" // red
            },
            {
              label: "A/C Receivable",
              value: "₦88,800,000",
              topIcon: DollarIcon4,
              bottomIcon: ArrowDown4,
              bottomText: "-12.5% from last month",
              bottomColor: "#90AAD6" // blue
            },
            {
              label: "A/C Payable",
              value: "₦4,800,000",
              topIcon: DollarIcon5,
              bottomIcon: ArrowDown5,
              bottomText: "+12.5% from last month",
              bottomColor: "#A855F7" // purple
            },
            {
              label: "Cash Flow",
              value: "₦4,800,000",
              topIcon: DollarIcon6,
              bottomIcon: ArrowDown6,
              bottomText: "+12.5% from last month",
              bottomColor: "#3B82F6" // amber
            }
          ].map((item, idx) => (
            <div className={classes.statCard} key={idx}>
              {/* top row */}
              <div className={classes.cardHeader}>
                <p className={classes.cardLabel}>{item.label}</p>
                <img src={item.topIcon} alt="" className={classes.cardTopIcon} />
              </div>

              {/* value */}
              <h3 className={classes.cardValue}>{item.value}</h3>

              {/* bottom row */}
              <div className={classes.cardFooter}>
                <img src={item.bottomIcon} alt="" className={classes.cardBottomIcon} />
                <span style={{ color: item.bottomColor }}>{item.bottomText}</span>
              </div>
            </div>
          ))}
        </div>
        <div className={classes.analyticsContainer}>
          {/* Card 1: Revenue vs Expenses */}
          <div className={classes.statCards}>
            <p className={classes.cardLabels}>Revenue vs Expenses</p>
            <p className={classes.cardSubLabels}>Monthly comparison</p>
            <ResponsiveContainer width="100%" height={200}>
              <LineChart data={revenueData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E4E4E4" />
                <XAxis dataKey="month" stroke="#092147" />
                <YAxis stroke="#092147" />
                <Tooltip />
                <Line
                  type="monotone"
                  dataKey="revenue"
                  stroke="#092147"
                  strokeWidth={3}
                  dot={{ r: 5, fill: "#092147" }}
                />
                <Line
                  type="monotone"
                  dataKey="expenses"
                  stroke="#90AAD6"
                  strokeWidth={3}
                  dot={{ r: 5, fill: "#90AAD6" }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>

          {/* Card 2: Cashflow Analysis */}
          <div className={classes.statCards}>
            <p className={classes.cardLabels}>Cashflow Analysis</p>
            <p className={classes.cardSubLabels}>Inflow vs Outflow</p>

            <ResponsiveContainer width="100%" height={200}>
              <AreaChart data={cashflowData}>
                <defs>
                  <linearGradient id="inflow" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#092147" stopOpacity={0.8} />
                    <stop offset="95%" stopColor="#092147" stopOpacity={0} />
                  </linearGradient>
                  <linearGradient id="outflow" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#90AAD6" stopOpacity={0.8} />
                    <stop offset="95%" stopColor="#90AAD6" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <XAxis dataKey="month" stroke="#092147" />
                <YAxis stroke="#092147" />
                <Tooltip />
                <Area
                  type="monotone"
                  dataKey="inflow"
                  stroke="#092147"
                  fill="url(#inflow)"
                  fillOpacity={0.6}
                />
                <Area
                  type="monotone"
                  dataKey="outflow"
                  stroke="#90AAD6"
                  fill="url(#outflow)"
                  fillOpacity={0.6}
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className={classes.financialContainer}>
          {/* Card 1: Profit & Loss */}
          <div className={classes.statCards}>
            <p className={classes.cardLabels}>Profit and Loss</p>
            <p className={classes.cardSubLabels}>Current Month Breakdown</p>
            <ResponsiveContainer width="100%" height='80%'>
              <BarChart data={profitLossData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E4E4E4" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="profit" fill="#90AAD6" />
                <Bar dataKey="loss" fill="#092147" />
              </BarChart>
            </ResponsiveContainer>
          </div>

          {/* Card 2: Top Expenses */}
          <div className={classes.statCards}>
            <p className={classes.cardLabels}>Top Expenses</p>
            <p className={classes.cardSubLabels}>By Category</p>
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie
                  data={expenseData}
                  cx="50%"
                  cy="50%"
                  outerRadius={70}
                  dataKey="value"
                  label
                >
                  {expenseData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
            <div className={classes.pieLegends}>
              {expenseData.map((item, idx) => (
                <div key={idx} className={classes.legendItem}>
                  <span
                    className={classes.legendDot}
                    style={{ backgroundColor: COLORS[idx] }}
                  />
                  {item.name}
                </div>
              ))}
            </div>
          </div>

          {/* Card 3: Bank Accounts */}
          <div className={classes.statCards}>
            <p className={classes.cardLabels}>Bank Accounts</p>
            <p className={classes.cardSubLabels}>Connected Accounts</p>
            <div className={classes.bankList}>
              {bankAccounts.map((acct, idx) => (
                <div key={idx} className={classes.bankItem}>
                  <div>
                    <p className={classes.bankName}>{acct.bank}</p>
                    <p className={classes.bankAccount}>{acct.account}</p>
                  </div>
                  <div className={classes.bankRight}>
                    <p className={classes.bankAmount}>{acct.amount}</p>
                    {acct.connected && (
                      <span className={classes.connectedBadge}>Connected</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={classes.transactionsRemitContainer}>
         
          <div className={classes.statCards}>
            <p className={classes.cardLabels}>Recent Transactions</p>
            <p className={classes.cardSubLabels}>Latest Financial Activity</p>
            <div className={classes.transactionList}>
              {transactions.map((t, idx) => (
                <div key={idx} className={classes.transactionItem}>
                  <div>
                    <p className={classes.transactionDesc}>{t.description}</p>
                    <p className={classes.transactionMeta}>
                      {t.time} • {t.type}
                    </p>
                  </div>
                  <div>
                    <p
                      className={`${classes.transactionAmount} ${t.amount > 0 ? "income" : "expense"
                        }`}
                    >
                      {t.amount > 0 ? `+₦${t.amount}` : `-₦${Math.abs(t.amount)}`}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          
          <div className={classes.statCards}>
            <p className={classes.cardLabels}>Outstanding Remittances</p>
            <p className={classes.cardSubLabels}>Pending Payments</p>
            <div className={classes.remittanceList}>
              {remittances.map((r, idx) => (
                <div key={idx} className={classes.remitItem}>
                  <div>
                    <p className={classes.remitBeneficiary}>{r.beneficiary}</p>
                    <p className={classes.remitMeta}>
                      {r.number} • {r.date}
                    </p>
                  </div>
                  <div className={classes.remitRight}>
                    <p className={classes.remitAmount}>{r.amount}</p>
                    <span className={classes.pendingBadge}>Pending</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountingDashboard;
